<template>
  <div>
    <pulse-loader :loading="loading.record" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading.record">
      <div class="mb-1 border-bottom">

        <AddSupplierCodes :task="{object_id: record003Id}"/>

        <!--        <table class="table table-sm mt-0 table-hover">-->
        <!--          <tbody>-->
        <!--          <tr>-->
        <!--            <td colspan="2"><strong>Коды к номенклатуре РК</strong></td>-->
        <!--          </tr>-->
        <!--          <template v-if="!hasPairedRecords(drugRecord.related_drugs)">-->
        <!--            <tr>-->
        <!--              <td colspan="2">Нет записей в базе</td>-->
        <!--            </tr>-->
        <!--          </template>-->
        <!--          <template v-else>-->
        <!--            <tr v-for="r in drugRecord.related_drugs" v-if="r.drug.details.length">-->
        <!--              <td>{{ r.drug.title }}</td>-->
        <!--              <td>-->
        <!--                <p v-for="c in r.drug.details">{{ c.text_value }}</p>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </template>-->
        <!--          <template v-if="!drugRecord.details.length && !drugRecord.related_drugs.length">-->
        <!--            <tr>-->
        <!--              <td colspan="2"><strong>Коды к номенклатуре 003ms</strong></td>-->
        <!--            </tr>-->
        <!--            <template v-if="!drugRecord.details.length && !drugRecord.related_drugs.length">-->
        <!--              <tr>-->
        <!--                <td colspan="2">Нет записей в базе</td>-->
        <!--              </tr>-->
        <!--            </template>-->
        <!--            <template v-else>-->
        <!--              <tr v-for="r in drugRecord.details">-->
        <!--                <td>{{ r.alias }}</td>-->
        <!--                <td>{{ r.value }}</td>-->
        <!--              </tr>-->
        <!--            </template>-->
        <!--          </template>-->
        <!--          </tbody>-->
        <!--        </table>-->
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import AddSupplierCodes from "@/views/tasks/components/AddSupplierCodes.vue";

export default {
  components: {AddSupplierCodes},
  props: ['record003Id'],
  data() {
    return {
      loading: {
        record: false,
      },
      drugRecord: null,
    }
  },
  created() {
    this.getRecords(true);
  },
  methods: {
    hasPairedRecords(records) {
      return records.find((r) => r.drug.details.length);
    },
    async getRecords(init = false) {
      this.loading.record = true;
      const {data} = await api.post('/statistics/003/codes', {
        action: 'getCodes',
        record_id: this.record003Id,
        code_type: 'uteka'
      });
      if (data.success) {
        this.drugRecord = data.record;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.record = false;
    }
  }
}

</script>

<style scoped>
label {
  font-weight: 500;
}

table td {
  padding: 2px 12px;
}
</style>
